import { useLocation, Outlet } from 'react-router-dom';
// @mui
import { Box, Link, Container, Typography, Stack, Divider, Grid, } from '@mui/material';
// components
import Logo from '../../components/Logo';
//
import Image from 'src/components/Image';

import { styled } from '@mui/material/styles';
import logo from 'src/assets/images/edu.webp'

import SocialsButton from '../../components/SocialsButton';

import MainFooter from './MainFooter';
import MainHeader from './MainHeader';
import Iconify from 'src/components/Iconify';


const LINKS = [
  {
    headline: 'Further Information',
    children: [
      { name: 'Made with love in Calgary!', href: '#', icon: "material-symbols:location-on-outline-rounded" },
      { name: '4038914091', href: 'tel:4038914091', icon: 'ic:baseline-call' },
      { name: 'hi@eduley.com', href: 'mailto:hi@eduley.com', icon: 'mdi:email-outline' },
    ],
  },
  // {
  //   headline: 'Help Center',
  //   children: [
  //     { name: 'Take your learning organisation to the next level.', href: '#' },
  //   ],
  // },
];

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.dark,
}));


// ----------------------------------------------------------------------

export default function MainLayout() {
  const { pathname } = useLocation();

  const isHome = pathname === '/';

  return (
    <Stack >
      <MainHeader />

      <Outlet />


      <Box sx={{ flexGrow: 1 }} />





      {false ? (
        <MainFooter />
      ) : (

        <RootStyle sx={{ bgcolor: '#050C12' }}>
          <Divider />


          <Container sx={{ color: 'common.white' }}>

            <Grid container

              sx={{
                mt: { xs: 2, md: 10 },
                pb: { xs: 2, md: 10 },
                fontSize: 13,
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              <Grid item xs={8} sm={3} md={3}

              >
                <Image
                  alt="Eduley Logo"
                  src={logo}
                  // ratio=""
                  sx={{
                    borderRadius: 1, width: '100%', marginLeft: '-35px',
                    width: '80%',
                    height: 'auto',
                    // boxShadow: shadow,
                  }}
                />

                <Typography variant="body" sx={{ pr: { md: 5 }, }}>
                  Take your learning organisation to the next level.
                </Typography>

                {/* <h4> Take your learning organisation to the next level.</h4> */}

              </Grid>
              <Grid item xs={12} sm={3} md={3} sx={{
                borderRight: { xs: '0px solid', md: '1px solid' }, textAlign: { xs: 'left' }
              }}>


                {LINKS.map((list) => (
                  <Stack key={list.headline} >
                    <h2 key={list.headline} style={{ paddingBottom: 10, marginBottom: 10 }}> {list.headline} </h2>
                    {list.children.map((link) => (
                      <Stack direction={'row'} spacing={3}>
                        <Iconify icon={link.icon} width={24} height={24} />
                        <>
                          {link.href != '#' ?
                            <Link
                              rel="noopener"
                              href={link.href}
                              key={link.name}
                              color="inherit"

                              variant="body2"
                              // component={RouterLink}
                              sx={{
                                display: 'block', pb: 2, '&:hover': {
                                  color: 'primary.main'
                                }
                              }}
                            >
                              {link.name}
                            </Link>
                            :
                            <Typography
                              variant='body2'
                              sx={{ display: 'block', pb: 2, }}
                            >
                              {link.name}
                            </Typography>}
                        </>
                      </Stack>
                    ))}
                  </Stack>
                ))}


              </Grid>

              <Grid item xs={12} sm={3} md={3} sx={{
                borderRight: { xs: '0px solid', md: '1px solid' },
                pl: { md: 2 }, textAlign: { xs: 'left' }
              }}>
                <h2 style={{ marginBottom: 10, }}> Follow Us </h2>
                <SocialsButton sx={{ mx: 0.5, color: 'white' }} />

              </Grid>

              <Grid item xs={12} sm={3} md={3} sx={{ pl: { md: 2 }, textAlign: { xs: 'left' } }} >
                <h2 style={{ marginBottom: 10, }}>Help Center</h2>
                <Typography variant="body" sx={{ pr: { md: 5 }, }}>
                  For any new Business or Partner enquiry? Please email us at  <Link
                    rel="noopener"
                    href={'mailto:help@eduley.com'}
                    // key={link.name}
                    // color="inherit"
                    //
                    variant="body2"
                    // component={RouterLink}
                    sx={{ display: '', pb: 2, color: 'primary.main' }}
                  >
                    help@eduley.com
                  </Link>
                </Typography>

              </Grid>

            </Grid>

            {/* <Grid item xs={4} md={4}>
            <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
           
              Take your learning organisation to the next level.
           
          </Grid>
          <Grid item xs={4} md={4}>

            <Stack
              direction="row"
            >
              <SocialsButton sx={{ mx: 0.5 }} />
            </Stack>
          </Grid>

          <Grid item xs={4} md={4}>
            <Stack
            >
              {LINKS.map((list) => (
                <Stack key={list.headline} >
                  <Typography variant="h6">
                    {list.headline}
                  </Typography>
                  {list.children.map((link) => (
                    <>
                      {link.href != '#' ?
                        <Link
                          rel="noopener"
                          href={link.href}
                          key={link.name}
                          color="inherit"

                          variant="body2"
                          // component={RouterLink}
                          sx={{ display: 'block' }}
                        >
                          {link.name}
                        </Link> :
                        <Typography
                          variant='body2'
                        >
                          {link.name}
                        </Typography>}
                    </>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
       
        <Typography
          component="p"
          variant="body2"
          sx={{
            mt: 10,
            pb: 5,
            fontSize: 13,
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          © 2022. All rights reserved
        </Typography> */}


          </Container>
        </RootStyle>

      )}

    </Stack>

  );
}
